export enum ClientType {
  NATURAL = 'NaturalPerson',
  JURIDICAL = 'JuridicalPerson'
}
